<template>
  <svg
    :class="['w-5 h-5 text-gray-500', className] | twMerge"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2026 14.9796C16.7258 14.9795 16.2686 14.8042 15.9315 14.4922L10.0112 9.0149L4.09099 14.4922C3.92514 14.6511 3.72676 14.7778 3.50742 14.865C3.28808 14.9521 3.05217 14.998 2.81345 14.9999C2.57474 15.0019 2.338 14.9598 2.11705 14.8761C1.89611 14.7925 1.69537 14.669 1.52657 14.5128C1.35777 14.3567 1.22427 14.1709 1.13388 13.9665C1.04348 13.7621 0.997994 13.5431 1.00007 13.3222C1.00214 13.1014 1.05174 12.8831 1.14596 12.6802C1.24018 12.4772 1.37715 12.2937 1.54886 12.1403L8.74017 5.487C9.07732 5.17517 9.53452 5 10.0112 5C10.488 5 10.9452 5.17517 11.2823 5.487L18.4736 12.1403C18.725 12.3729 18.8961 12.6692 18.9655 12.9918C19.0348 13.3144 18.9992 13.6488 18.8632 13.9527C18.7271 14.2566 18.4968 14.5164 18.2012 14.6991C17.9056 14.8819 17.5581 14.9795 17.2026 14.9796Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'ChevronUpFilled',
  props: {
    className: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
